/* ==========================================================================
   Slider (CSS scroll-snap + minimal JS)
   Used for horizontal carousels (e.g. submenu with images, product galleries)
   ========================================================================== */
export default function addSlider() {
    const sliders = document.querySelectorAll('[data-component="slider"]');
    sliders.forEach((slider) => {
        const track = slider.querySelector('.slider__wrapper');
        const btnPrev = slider.querySelector('.slider__btn--prev');
        const btnNext = slider.querySelector('.slider__btn--next');
        const items = slider.querySelectorAll('.slider__slide');
        if (!track)
            return;
        // Prev/next: scroll by one slide width + flex gap
        const getScrollAmount = () => {
            const item = track.querySelector('.slider__slide');
            if (!item)
                return 200;
            const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
            return item.offsetWidth + gap;
        };
        const updateButtons = () => {
            if (btnPrev)
                btnPrev.disabled = track.scrollLeft <= 0;
            if (btnNext)
                btnNext.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        };
        btnPrev?.addEventListener('click', () => {
            track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
        btnNext?.addEventListener('click', () => {
            track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        updateButtons();
        // Accessibility: hide off-screen slides from assistive tech and Tab order.
        // aria-hidden="true" — hides the slide subtree from screen readers.
        // tabindex="-1" on links/buttons — focus cannot land inside hidden slides
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const focusables = entry.target.querySelectorAll('a, button');
                if (entry.isIntersecting) {
                    entry.target.removeAttribute('aria-hidden');
                    focusables.forEach((el) => { el.tabIndex = 0; });
                }
                else {
                    entry.target.setAttribute('aria-hidden', 'true');
                    focusables.forEach((el) => { el.tabIndex = -1; });
                }
            });
        }, { root: track, threshold: 0.5 } // threshold 0.5 — slide is “visible” when at least half intersects the track.
        );
        items.forEach((item) => observer.observe(item));
    });
}
